import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateInventory = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) return;

    morph(this, newInventory, { childrenOnly: true });
    this.#syncVisibility(newInventory);
  };

  /**
   * Keeps host visibility in sync when "only low stock" hides the block.
   * @param {Element} source
   */
  #syncVisibility(source) {
    if (source.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
      this.classList.add('product-inventory--hidden');
    } else {
      this.removeAttribute('hidden');
      this.classList.remove('product-inventory--hidden');
    }
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
